import {gql} from 'apollo-angular';

export const DELETE_BOOKMARK = gql`
  query DeleteBookmark($code: String!) {
    bookmarkDelete(code: $code)
  }
`;
